import styled from "styled-components";
import {
  MessageQuestion,
  UserImg,
  logout,
  people,
  person1,
  profilePic,
  setting,
  user_values,
} from "../../../../public/assets";
import fipayFonts from "../../../theme";
import { colors } from "../../../theme/color";
import logOut from "../../../utils/Logout/logout";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearStorage } from "../../../store";
import OutsideClickHandler from "../../OutsideClickHandler/OutsideClickHandler";
import { RootState } from "../../../store/rootReducer";
import { useQuery } from "@apollo/client";
import { GET_USER_BY_ID } from "../../../graphql/queries/userManagement";
import { setIsLoggedIn } from "../../../store/auth/authSlice";

const DropdownMainCon = styled.div`
  // width: 83%;
  background: white;
  box-shadow: -5px 4px 30px 0px #bec4c940;
  margin-left: 80px;
  border-radius: 10px;

  @media only screen and (max-width: 768px) {
    margin-right: 1700px;
    width: 75%;
  }

  @media only screen and (max-width: 1024px) {
    width: 75%;
    margin-left: 80px;
  }

  @media only screen and (max-width: 1440px) {
    width: 80%;
  }

  @media only screen and (max-width: 1680px) {
    width: 80%;
  }

  @media (min-width: 425px) {
    /* margin-left: -40px; */
    margin-right: 0;
    width: 100%;
  }

  @media only screen and (max-width: 375px) {
    /* margin-left: -90px; */
    margin-right: 0;
    width: 159%;
  }
`;

const DropdownNameCon = styled.div`
  display: flex;
  align-items: center;
  align-content: center;
  padding: 10px 0px 5px 15px;
`;

const DropdownProfilePicCon = styled.div``;

const DropdownNameTag = styled.span`
  padding-left: 10px;
  color: ${colors.BLACK};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.medium};

  @media (min-width: 425px) {
    /* margin-left: 20px; */
    /* border: 2px solid red; */
  }
`;

const DropdownEmailTag = styled.span`
  padding-left: 10px;
  padding-top: 15px;
  font-size: ${fipayFonts.fipayFonts.fontSize.footer1};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  color: ${colors.GRAY};
  letter-spacing: ${fipayFonts.fipayFonts.letterSpacing.body0};
  text-transform: uppercase;
`;

const HorizontalLine = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 10px;
  width: 100%;
  margin: 0 auto;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const HorizontalSpan = styled.span`
  flex-grow: 1;
  height: 1px;
  background-color: #e8eaed;
`;

const DropdownInfoCon = styled.div`
  padding-left: 15px;
  align-items: center;
  align-content: center;
`;

const DropdownInfo1 = styled.div`
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const DropdownInfo = styled.div`
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const DropdownInfo2 = styled.div`
  display: flex;
  align-items: center;
  padding-top: 10px;
  padding-bottom: 20px;
  padding-left: 15px;
`;

const DropdownTag = styled.span`
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  color: ${colors.NEUTRAL_NEUTRAL};
  padding-left: 8px;
`;

const DropdownLogOut = styled.span`
  padding-left: 10px;
  font-size: ${fipayFonts.fipayFonts.fontSize.body3};
  font-weight: ${fipayFonts.fipayFonts.fontWeight.regular};
  color: ${colors.DANGER};
`;

interface DropDownAccountProps {
  setShowDiv: (state: boolean) => void;
  showDiv: boolean;
}

const DropDownAccount: React.FC<DropDownAccountProps> = ({
  setShowDiv,
  showDiv,
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleLogout = () => {
    dispatch(clearStorage());
    window.location.href = "/auth/login";
  };

  const id = useSelector((state: RootState) => state.user?.user.id);

  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useQuery(GET_USER_BY_ID);

  const userDetails = queryData?.getUserById;

  return (
    <OutsideClickHandler
      showDiv={setShowDiv}
      show={showDiv}
      className="outsideClick"
    >
      <DropdownMainCon>
        <DropdownNameCon style={{ display: "none" }}>
          <DropdownProfilePicCon>
            <img src="/assets/Ellipse 1.png" alt="Profile" />
          </DropdownProfilePicCon>
          <div>
            <DropdownNameTag>
              {userDetails?.fullName ? userDetails.fullName : ""}
            </DropdownNameTag>
            <br />
            <DropdownEmailTag>
              {userDetails?.accountType
                ? userDetails.accountType.toUpperCase()
                : ""}
            </DropdownEmailTag>
          </div>
        </DropdownNameCon>
        <HorizontalLine>
          <HorizontalSpan></HorizontalSpan>
        </HorizontalLine>
        <DropdownInfoCon>
          {/*<DropdownInfo1>*/}
          {/*  <img src="/assets/svg/user.svg" alt="" />{" "}*/}
          {/*  <DropdownTag>Profile</DropdownTag>{" "}*/}
          {/*</DropdownInfo1>*/}
          <DropdownInfo>
            <img src="/assets/setting.png" alt="" />{" "}
            <DropdownTag>Setting</DropdownTag>{" "}
          </DropdownInfo>
          <DropdownInfo>
            <img src="/assets/svg/message-question.svg" alt="" />{" "}
            <DropdownTag>Support</DropdownTag>{" "}
          </DropdownInfo>
        </DropdownInfoCon>
        <div>
          <HorizontalLine>
            <HorizontalSpan></HorizontalSpan>
          </HorizontalLine>
          <DropdownInfo2 onClick={handleLogout}>
            <img src="/assets/logout.png" alt="" />{" "}
            <DropdownLogOut>Log Out</DropdownLogOut>{" "}
          </DropdownInfo2>
        </div>
      </DropdownMainCon>
    </OutsideClickHandler>
  );
};

export default DropDownAccount;
